import React, { useState } from 'react'
import { useAlert } from 'react-alert'
import { Link } from 'react-router-dom'
import Mailgun from 'mailgun.js'
import formData from 'form-data'
import { saveUserData } from '../providers/policy'

const initialState = {
  email: '',
  message: '',
  name: '',
  cellphone: '',
}

/**
 * Componente para mostrar el footer. La información que se muestra aquí, se cargan a través 
 * del archivo .src/data/data.json -> "Contact"
 *
 * @component
 * @example
 * 
 * "Contact": {
    "address": "Quito - Ecuador",
    "address2": "Guipuzcoa E14-46 y Mallorca",
    "address3": "Mallorca.",
    "address4": "Edificio QPH",
    "address5": "Lima - Perú",
    "address6": "Calle las Casas 153 San Isidro",
    "phone": "(02) 3 956 060",
    "email": "info@rangle.ec",
    "linkedin": "https://www.linkedin.com/company/right-angle-media-consultora/about/?viewAsMember=true",
    "instagram": "https://www.instagram.com/right.angle.media",
    "followas": "Síguenos"
  }
 */

export const Contact = (props) => {
  const [width, setWidth] = React.useState(window.innerWidth)
  const [policy, setPolicy] = React.useState(false)
  const [sending, setSending] = React.useState(false)
  const [error, setError] = React.useState({ email: false })
  const breakpoint = 620

  React.useEffect(() => {
    /* Inside of a "useEffect" hook add an event listener that updates
      the "width" state variable when the window size changes */
    window.addEventListener('resize', () => setWidth(window.innerWidth))

    /* passing an empty array as the dependencies of the effect will cause this
      effect to only run when the component mounts, and not each time it updates.
      We only want the listener to be added once */
  }, [])

  const API_KEY = 'b4c472c9d84d4d7cb254f2aded961b5f-7ca144d2-e90fcace'
  const DOMAIN = 'mg.rangle.ec'

  const alert = useAlert()
  const [{ email, message, cellphone, name }, setState] = useState(initialState)

  const mailgun = new Mailgun(formData)
  const client = mailgun.client({ username: 'api', key: API_KEY })

  const handleChange = (e) => {
    const { name, value } = e.target
    setState((prevState) => ({ ...prevState, [name]: value }))
  }
  const clearState = () => {
    setState({ ...initialState })
    setPolicy(false)
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    setSending(true)
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    const validEmail = emailRegex.test(email)
    if (!policy || !validEmail) {
      setError({ email: !validEmail })
      if (!policy)
        alert.error('Debes aceptar la política de datos para continuar.')
      setSending(false)
      return
    }

    try {
      const response = await fetch("https://api.ipify.org?format=json")
      const data = await response.json()

      const userAgent = navigator.userAgent;
      let browserName;

      if (userAgent.indexOf("Chrome") > -1) {
        browserName = "Google Chrome";
      } else if (userAgent.indexOf("Safari") > -1) {
        browserName = "Apple Safari";
      } else if (userAgent.indexOf("Opera") > -1) {
        browserName = "Opera";
      } else if (userAgent.indexOf("Firefox") > -1) {
        browserName = "Mozilla Firefox";
      } else if (userAgent.indexOf("MSIE") > -1) {
        browserName = "Microsoft Internet Explorer";
      }

      const contact = {
        contact_data: {
          contact_id: email,
          ip_dir: data.ip,
          browser: browserName,
          method: "Casilla de verificación de la página web"
        }
      }

      saveUserData(contact)
    } catch (error) {
      // console.log(error)
    }


    const messageData = {
      from: email,
      to: 'info@rangle.ec',
      // to: email,
      subject: 'Ha recibido un mensaje desde la página de RAM ' + email,
      html: `<p>Nombre: ${name}</p><p>Email: ${email}</p><p>Teléfono: ${cellphone}</p><p>Mensaje: ${message}</p>`,
    }

    const messageData2 = {
      from: 'info@rangle.ec',
      to: email,
      subject: 'Hemos recibido su mensaje',
      html:
        '<style type="text/css">html, body, div, form, fieldset, legend, label, img, tr{margin: 0;padding: 0;}table{border-collapse: collapse;border-spacing: 0;    font-size:0;}th, td{text-align: left;}h1, h2, h3, h4, h5, h6, th, td, caption { font-weight:normal; }img { border: 0; display:block; padding:0; margin:0;}span.preheader{display:none !important;}</style><body><table width="100%"><tr><td><center><table style="display: inline-table; background-color: #f8c947;" border="0" cellpadding="0" cellspacing="0" width="700">  <tr>   <td><img style="border: 0; display:block; padding:0; margin:0;" name="n20230913ram_web_r1_c1" src="https://mailling-img.s3.amazonaws.com/RAM/2023-09-13-ram_web/img/2023-09-13-ram_web_r1_c1.jpg" width="700" height="576" id="n20230913ram_web_r1_c1" alt="" /></td>  </tr>  <tr>   <td><table style="display: inline-table;" align="left" border="0" cellpadding="0" cellspacing="0" width="700">	  <tr>	   <td><img style="border: 0; display:block; padding:0; margin:0;" name="n20230913ram_web_r2_c1" src="https://mailling-img.s3.amazonaws.com/RAM/2023-09-13-ram_web/img/2023-09-13-ram_web_r2_c1.jpg" width="264" height="23" id="n20230913ram_web_r2_c1" alt="" /></td>	   <td><a href="' +
        window.location.origin +
        '/AnalyticNews" target="_blank"><img name="n20230913ram_web_r2_c3" src="https://mailling-img.s3.amazonaws.com/RAM/2023-09-13-ram_web/img/2023-09-13-ram_web_r2_c3.jpg" width="174" height="23" id="n20230913ram_web_r2_c3" alt="Politica de Privacidad" /></a></td>	   <td><img style="border: 0; display:block; padding:0; margin:0;" name="n20230913ram_web_r2_c5" src="https://mailling-img.s3.amazonaws.com/RAM/2023-09-13-ram_web/img/2023-09-13-ram_web_r2_c5.jpg" width="262" height="23" id="n20230913ram_web_r2_c5" alt="" /></td>	  </tr>	</table></td>  </tr>  <tr>   <td><img style="border: 0; display:block; padding:0; margin:0;" name="n20230913ram_web_r3_c1" src="https://mailling-img.s3.amazonaws.com/RAM/2023-09-13-ram_web/img/2023-09-13-ram_web_r3_c1.jpg" width="700" height="51" id="n20230913ram_web_r3_c1" alt="" /></td>  </tr>  <tr>   <td><table style="display: inline-table;" align="left" border="0" cellpadding="0" cellspacing="0" width="700">	  <tr>	   <td><img style="border: 0; display:block; padding:0; margin:0;" name="n20230913ram_web_r4_c1" src="https://mailling-img.s3.amazonaws.com/RAM/2023-09-13-ram_web/img/2023-09-13-ram_web_r4_c1.jpg" width="236" height="32" id="n20230913ram_web_r4_c1" alt="" /></td>	   <td><a href="mailto:info@rangle.ec" target="_blank"><img style="border: 0; display:block; padding:0; margin:0;" name="n20230913ram_web_r4_c2" src="https://mailling-img.s3.amazonaws.com/RAM/2023-09-13-ram_web/img/2023-09-13-ram_web_r4_c2.jpg" width="114" height="32" id="n20230913ram_web_r4_c2" alt="info@rangle.ec" /></a></td>	   <td><a href="https://www.linkedin.com/company/right-angle-media-consultora/about/?viewAsMember=true" target="_blank"><img name="n20230913ram_web_r4_c4" src="https://mailling-img.s3.amazonaws.com/RAM/2023-09-13-ram_web/img/2023-09-13-ram_web_r4_c4.jpg" width="122" height="32" id="n20230913ram_web_r4_c4" alt="LInkeding" /></a></td>	   <td><img style="border: 0; display:block; padding:0; margin:0;" name="n20230913ram_web_r4_c6" src="https://mailling-img.s3.amazonaws.com/RAM/2023-09-13-ram_web/img/2023-09-13-ram_web_r4_c6.jpg" width="228" height="32" id="n20230913ram_web_r4_c6" alt="" /></td>	  </tr>	</table></td>  </tr>  <tr>   <td><img style="border: 0; display:block; padding:0; margin:0;" name="n20230913ram_web_r5_c1" src="https://mailling-img.s3.amazonaws.com/RAM/2023-09-13-ram_web/img/2023-09-13-ram_web_r5_c1.jpg" width="700" height="112" id="n20230913ram_web_r5_c1" alt="" /></td>  </tr></table></center></td></tr></table></body></html>',
    }

    client.messages
      .create(DOMAIN, messageData)
      .then((res) => {
        client.messages
          .create(DOMAIN, messageData2)
          .then((res) => {
            alert.success('¡Su mensaje ha sido enviado correctamente!')
            clearState()
            setSending(false)
          })
          .catch((err) => {
            console.error(err)
            alert.error(
              'Ha ocurrido un error al enviar su mensaje. ' + err.text
            )
            setSending(false)
          })
      })
      .catch((err) => {
        console.error(err)
        alert.error('Ha ocurrido un error al enviar su mensaje. ' + err.text)
        setSending(false)
      })
  }
  return (
    <div>
      <div id="contactanos">
        <div className="container-fluid padding-fluid padding-fluid-mob">
          <div className="col-lg-6 col-md-6 col-xs-12">
            <div className="row">
              <form name="sentMessage" validate="true" onSubmit={handleSubmit}>
                <div className="row">
                  <div className="section-title col-md-offset-0 col-xs-10 col-xs-offset-1">
                    <p>Consigamos resultados extraordinarios</p>
                  </div>
                  <div className="col-md-10 col-md-offset-0 col-xs-10 col-xs-offset-1">
                    <div className="form-group">
                      <input
                        type="text"
                        id="name"
                        name="name"
                        className="form-control"
                        placeholder="Nombre y apellido"
                        required
                        onChange={handleChange}
                        value={name}
                      />
                      <p className="help-block text-danger"></p>
                    </div>
                  </div>
                  <div className="col-md-10 col-md-offset-0 col-xs-10 col-xs-offset-1">
                    <div className="form-group">
                      <input
                        type="email"
                        id="email"
                        name="email"
                        className="form-control"
                        placeholder="your@email.com"
                        onChange={handleChange}

                        value={email}
                      />
                      {error.email ? <p className="help-block h6 text-danger" style={{ paddingLeft: 10, opacity: 0.8 }}>Debes ingresar un correo válido</p> : null}
                    </div>
                  </div>
                  <div className="col-md-10 col-md-offset-0 col-xs-10 col-xs-offset-1">
                    <div className="form-group">
                      <input
                        type="tel"
                        id="cellphone"
                        name="cellphone"
                        className="form-control"
                        placeholder="Teléfono"
                        required
                        onChange={handleChange}
                        value={cellphone}
                      />
                      <p className="help-block text-danger"></p>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-10 col-md-offset-0 col-xs-10 col-xs-offset-1">
                    <textarea
                      name="message"
                      id="message"
                      className="form-control"
                      rows={width < breakpoint ? '8' : '4'}
                      placeholder="Mensaje"
                      required
                      onChange={handleChange}
                      value={message}
                    ></textarea>
                    {/* <div className="visible-xs btn-mobile">
                      <button
                        type="submit"
                        aria-label="enviarMail"
                        className="btn btn-custom"
                      >
                        <i className="fa fa-arrow-right"></i>
                      </button>
                    </div> */}
                    <p className="help-block text-danger"></p>
                  </div>
                  <div className="col-md-10 col-md-offset-0 col-xs-10 col-xs-offset-1">
                    <div
                      className="form-group"
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                      }}
                    >
                      <div
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                        }}
                      >
                        <input
                          // required
                          id="policy"
                          name="policy"
                          type="checkbox"
                          checked={policy}
                          onChange={() => setPolicy(!policy)}
                          style={{ alignSelf: 'center', margin: '0px' }}
                        />
                        <label
                          htmlFor="policy"
                          style={{ marginLeft: '10px', marginBottom: '0px' }}
                        >
                          Acepto{' '}
                          <a
                            className="linkPoliticas"
                            href="/AnalyticNews"
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            política de datos
                          </a>
                        </label>
                      </div>
                      <button
                        type="submit"
                        disabled={sending}
                        aria-label="enviarMail"
                        className="btn btn-custom"
                      >
                        <i className="fa fa-arrow-right"></i>
                      </button>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
          <div className="col-md-6 col-xs-12 contact-info-container">
            <div className="col-md-6 col-xs-6 contact-info">
              <div>
                <h3>News</h3>

                {props.dataNews
                  ? props.dataNews.slice(0, 3).map((d, i) => (
                    <Link key={`lnk${i}`} to={d.url}>
                      <p
                        className="textNew"
                        dangerouslySetInnerHTML={{ __html: d.shortText }}
                        key={`p${i}`}
                      ></p>
                    </Link>
                  ))
                  : ''}
              </div>
              <div>&nbsp;</div>
              <div>
                <h3>Menú</h3>
                <h5>
                  <Link className="titleLink" to="/services">
                    Nuestros Servicios
                  </Link>
                </h5>
                <div className="ourServices">
                  {props.dataServices
                    ? props.dataServices.map((d, i) => (
                      <Link key={`lnk2${i}`} to={d.url}>
                        <p className="textNew" key={`p${i}`}>
                          {d.name}
                        </p>
                      </Link>
                    ))
                    : ''}
                </div>
                <h5>
                  <Link className="titleLink" to="/briefcase">
                    Nuestro Trabajo
                  </Link>
                </h5>
                <h5>
                  <Link className="titleLink" to="/clients">
                    Clientes
                  </Link>
                </h5>
                <h5>
                  <Link className="titleLink" to="/team">
                    Equipo
                  </Link>
                </h5>
              </div>
            </div>
            <div className="col-md-6 col-xs-6 contact-info">
              <div>
                <h3>Contáctanos</h3>
                <p>
                  <span></span> {props.data ? props.data.phone : 'loading'}
                  <br></br>
                  <span>
                    <i className="fa fa-envelope-o"></i>
                  </span>{' '}
                  {props.data ? props.data.email : 'loading'}
                </p>
              </div>
              <div className="contact-item">
                <p>
                  <span>Nuestra Ubicación:</span>
                  {props.data ? props.data.address : 'loading'}
                  <br></br>
                  {props.data ? props.data.address2 : 'loading'}
                  <br></br>
                  {/* {props.data ? props.data.address3 : "loading"}<br></br> */}
                  {props.data ? props.data.address4 : 'loading'}
                  <br></br>
                  <br></br>
                  {props.data ? props.data.address5 : 'loading'}
                  <br></br>
                  {props.data ? props.data.address6 : 'loading'}
                </p>
              </div>
              <div className="contact-item">
                <p>
                  <a
                    className="linkPoliticas"
                    href="/AnalyticNews"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Protección de Datos
                  </a>
                  <br></br>
                  <a
                    className="linkPoliticas"
                    href="/CookiesPolicy"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Política de Cookies
                  </a>
                </p>
              </div>
              <div className="contact-item">
                <h5>Nuestros Logros</h5>

                <div className="col-md-12" style={{ padding: 0 }}>
                  <div
                    className="col-md-4 "
                    style={{ paddingLeft: 0, paddingBottom: 15 }}
                  >
                    <img
                      alt=""
                      className="img-responsive"
                      src="/img/clients/meta.webp"
                    ></img>
                  </div>
                  <div
                    className="col-md-4 "
                    style={{ paddingLeft: 0, paddingBottom: 15 }}
                  >
                    <img
                      alt=""
                      className="img-responsive"
                      src="/img/clients/lux.webp"
                    ></img>
                  </div>
                  <div
                    className="col-md-4 "
                    style={{ paddingLeft: 0, paddingBottom: 15 }}
                  >
                    <img
                      alt=""
                      className="img-responsive"
                      src="/img/clients/google_partner.webp"
                    ></img>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="container-fluid padding-fluid padding-fluid-mob">
          <div className="social">
            <ul>
              <li>
                <h3>{props.data ? props.data.followas : 'loading'}</h3>
              </li>
              <br className="salto"></br>
              <li>
                <a
                  aria-label="instagram"
                  href={props.data ? props.data.instagram : '/'}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i className="fa-brands fa-instagram"></i>
                </a>
              </li>
              <li>
                <a
                  aria-label="linkedin"
                  href={props.data ? props.data.linkedin : '/'}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i className="fa-brands fa-linkedin"></i>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  )
}
